import { useQuery } from '@tanstack/react-query'

import { venueTrustSignalQueries } from '~/client/venue/venue-trust-signal.queries'
import type { VenueTrustSignalDomain } from '~/shared/venue/trust-signals'

export function useVenueTrustSignalDetails(
  venueId: number | null | undefined,
  sourceDomain: VenueTrustSignalDomain | null,
) {
  return useQuery(venueTrustSignalQueries.details(venueId, sourceDomain))
}
